import React from "react";
import { Tooltip } from "@/components/common/Tooltip";
import CheckIcon from "@mui/icons-material/Check";

interface SelectCheckboxProps {
  selected: boolean;
  onToggle: (e: React.MouseEvent) => void;
  tooltip?: { checked: string; unchecked: string };
  size?: "sm" | "md";
  /// Accessible name for the checkbox (screen readers + tests). Prefer this
  /// when the control isn't paired with a `<label>`.
  ariaLabel?: string;
}

export const SelectCheckbox: React.FC<SelectCheckboxProps> = ({
  selected,
  onToggle,
  tooltip,
  size = "md",
  ariaLabel,
}) => {
  const sizeClasses = size === "sm" ? "size-3.5" : "size-4";
  const iconSize = size === "sm" ? 10 : 12;

  const checkbox = (
    <button
      type="button"
      role="checkbox"
      aria-checked={selected}
      aria-label={ariaLabel}
      onClick={onToggle}
      className={`shrink-0 ${sizeClasses} rounded-sm border flex items-center justify-center cursor-pointer transition-colors ${
        selected
          ? "bg-accent-15 border-accent"
          : "bg-transparent border-border hover:border-accent"
      }`}
    >
      {selected && (
        <CheckIcon sx={{ fontSize: iconSize, color: "var(--color-accent)" }} />
      )}
    </button>
  );

  if (tooltip) {
    return (
      <Tooltip title={selected ? tooltip.checked : tooltip.unchecked}>
        {checkbox}
      </Tooltip>
    );
  }

  return checkbox;
};
